import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {HomematchRejectReason} from "../types/IHomematchPrelead";

export interface IRejectHomematchPreleadPayload {
    preleadId: number;
    reasons: HomematchRejectReason[];
    reasonDescription?: string;
}

/** 409 body of a failed accept — the account misses data required to create a lead. */
export interface IHomematchLeadRequirementsError {
    code: "lead_requirements_not_met";
    detail: string;
    missing: string[];
}

const getPreleadActionUrl = (preleadId: number, actionPath: string): string => `${apiUserLink.homeMatch.preleads}${preleadId}/${actionPath}/`;

/**
 * Swipe actions of the tinder deck. Accept and reject invalidate the
 * prelead list: the backend refills the buffer after a swipe, so the refetch
 * both updates the homepage teaser and feeds new cards into the deck.
 */
export const homematchPreleadActionsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        patchAcceptHomematchPrelead: builder.mutation<void, {preleadId: number}>({
            query: ({preleadId}) => ({
                url: getPreleadActionUrl(preleadId, "accept"),
                method: "PATCH"
            }),
            invalidatesTags: ["HomematchPreleads"]
        }),
        patchRejectHomematchPrelead: builder.mutation<void, IRejectHomematchPreleadPayload>({
            query: ({preleadId, reasons, reasonDescription}) => ({
                url: getPreleadActionUrl(preleadId, "reject"),
                method: "PATCH",
                body: {
                    reasons,
                    ...(reasonDescription ? {reason_description: reasonDescription} : {})
                }
            }),
            invalidatesTags: ["HomematchPreleads"]
        }),
        patchMarkHomematchPreleadShown: builder.mutation<void, {preleadId: number}>({
            query: ({preleadId}) => ({
                url: getPreleadActionUrl(preleadId, "mark_shown"),
                method: "PATCH"
            })
        })
    }),
    overrideExisting: false
});

export const {usePatchAcceptHomematchPreleadMutation, usePatchRejectHomematchPreleadMutation, usePatchMarkHomematchPreleadShownMutation} =
    homematchPreleadActionsApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {HomematchRejectReason} from "../types/IHomematchPrelead";

export interface IRejectHomematchPreleadPayload {
    preleadId: number;
    reasons: HomematchRejectReason[];
    reasonDescription?: string;
}

/** 409 body of a failed accept — the account misses data required to create a lead. */
export interface IHomematchLeadRequirementsError {
    code: "lead_requirements_not_met";
    detail: string;
    missing: string[];
}

const getPreleadActionUrl = (preleadId: number, actionPath: string): string => `${apiUserLink.homeMatch.preleads}${preleadId}/${actionPath}/`;

/**
 * Swipe actions of the tinder deck. Accept and reject invalidate the
 * prelead list: the backend refills the buffer after a swipe, so the refetch
 * both updates the homepage teaser and feeds new cards into the deck.
 */
export const homematchPreleadActionsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        patchAcceptHomematchPrelead: builder.mutation<void, {preleadId: number}>({
            query: ({preleadId}) => ({
                url: getPreleadActionUrl(preleadId, "accept"),
                method: "PATCH"
            }),
            invalidatesTags: ["HomematchPreleads"]
        }),
        patchRejectHomematchPrelead: builder.mutation<void, IRejectHomematchPreleadPayload>({
            query: ({preleadId, reasons, reasonDescription}) => ({
                url: getPreleadActionUrl(preleadId, "reject"),
                method: "PATCH",
                body: {
                    reasons,
                    ...(reasonDescription ? {reason_description: reasonDescription} : {})
                }
            }),
            invalidatesTags: ["HomematchPreleads"]
        }),
        patchMarkHomematchPreleadShown: builder.mutation<void, {preleadId: number}>({
            query: ({preleadId}) => ({
                url: getPreleadActionUrl(preleadId, "mark_shown"),
                method: "PATCH"
            })
        })
    }),
    overrideExisting: false
});

export const {usePatchAcceptHomematchPreleadMutation, usePatchRejectHomematchPreleadMutation, usePatchMarkHomematchPreleadShownMutation} =
    homematchPreleadActionsApi;
